<ion-content (click)="closeModal()">
  <img class="top_logo" src="assets/icon/em_icon.svg" alt="EnergyMaster">
  <div class="w-full h-[calc(100%-208px)] flex items-end">

    <div class="grid grid-cols-1 px-1 w-full gap-2">
      <app-user-avatar
        class="ml-5 mb-5 size-28 shrink-0"
        [user]="user"
        tone="primary"
      />
      <div
        class="-mt-16 ml-26 bg-background rounded-xl border-2 border-dark-tint w-12 h-12 flex items-center justify-center">
        <fa-icon [icon]="faPen" aria-hidden="true" class="text-white text-lg "></fa-icon>
      </div>

      <div class="text-white text-4xl pb-5 pl-5">
        @if (user) {
          {{ user.first_name }} <br>
          {{ user.last_name }}
        }
      </div>
      <ion-button fill="clear" class="normal-case text-lg" color="light" [shape]="'round'" [routerLink]="'/notifications'">
        <div class="flex w-full items-center justify-start text-left">
          <fa-icon [icon]="faBell" aria-hidden="true" class="menu-icon"></fa-icon>
          <span class="menu-button"> {{ 'menu.notifications' | translate }}</span>
        </div>
      </ion-button>
      <ion-button fill="clear" class="normal-case text-lg" color="light" [shape]="'round'" [routerLink]="'/user/detail'">
        <div class="flex w-full items-center justify-start text-left">
          <fa-icon [icon]="faUser" aria-hidden="true" class="menu-icon"></fa-icon>
          <span class="menu-button">{{ 'menu.my_profile' | translate }}</span>
        </div>
      </ion-button>
      <ion-button fill="clear" class="normal-case text-lg" color="light" [shape]="'round'" [routerLink]="'/user/dashboard'">
        <div class="flex w-full items-center justify-start text-left">
          <fa-icon [icon]="faUserGroup" aria-hidden="true" class="menu-icon"></fa-icon>
          <span class="menu-button">{{ 'menu.users' | translate }}</span>
        </div>
      </ion-button>
      <ion-button fill="clear" class="normal-case text-lg" color="light" [shape]="'round'" [routerLink]="'/settings'">
        <div class="flex w-full items-center justify-start text-left">
          <fa-icon [icon]="faGear" aria-hidden="true" class="menu-icon"></fa-icon>
          <span class="menu-button">{{ 'menu.app_settings' | translate }}</span>
        </div>
      </ion-button>
      @if (user?.role === 'system_admin' || user?.role === 'root_admin') {
        <ion-button fill="clear" class="normal-case text-lg" color="light" shape="round" routerLink="/csv-imports">
          <div class="flex w-full items-center justify-start text-left">
            <fa-icon [icon]="faGear" aria-hidden="true" class="menu-icon"></fa-icon>
            <span class="menu-button">{{ 'csv_import.title' | translate }}</span>
          </div>
        </ion-button>
      }


    </div>
  </div>
</ion-content>
